import { useCallback, useContext } from "react";
import { ScrollContext } from "../containers/scrollContextProvider/scrollContextProvider";

function useScrollToTop() {
  const { scrollbarRef } = useContext(ScrollContext);

  return useCallback(() => {
    const scrollTop = () => {
      scrollbarRef.current?.update?.("sync");
      scrollbarRef.current?.scroll({
        x: 0,
        y: 0,
      });
      window.scrollTo({ top: 0, left: 0 });
    };

    scrollTop();
    requestAnimationFrame(scrollTop);
  }, [scrollbarRef]);
}

export default useScrollToTop;
